import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Sidebar } from '../components/layout/Sidebar';
import { Header } from '../components/layout/Header';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <div className="flex min-h-screen bg-[var(--ccb-bg)]">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
